<template>
  <div>
    <!-- card -->
    <div
        v-if="card"
        class="payment-card max-w-md cursor-pointer card-gradient rounded-lg overflow-hidden md:max-w-sm transform transition-transform duration-500 hover:scale-105"
        @click="showModal = true"
    >
      <div class="md:flex">
        <div class="w-full p-4">
          <div class="flex justify-between items-center text-white">
            <span class="text-2xl font-bold leading-none">{{ cardType }}</span>
            <span class="visible-on-hover text-xs invisible">click to change</span>
          </div>
          <div class="flex justify-between items-center mt-10">
            <div class="flex flex-row">
              <img class="w-4 h-4" src="@/assets/images/card_asterisk.png"/>
              <img class="w-4 h-4" src="@/assets/images/card_asterisk.png"/>
              <img class="w-4 h-4" src="@/assets/images/card_asterisk.png"/>
              <img class="w-4 h-4" src="@/assets/images/card_asterisk.png"/>
            </div>
            <div class="flex flex-row">
              <img class="w-4 h-4" src="@/assets/images/card_asterisk.png"/>
              <img class="w-4 h-4" src="@/assets/images/card_asterisk.png"/>
              <img class="w-4 h-4" src="@/assets/images/card_asterisk.png"/>
              <img class="w-4 h-4" src="@/assets/images/card_asterisk.png"/>
            </div>
            <div class="flex flex-row">
              <img class="w-4 h-4" src="@/assets/images/card_asterisk.png"/>
              <img class="w-4 h-4" src="@/assets/images/card_asterisk.png"/>
              <img class="w-4 h-4" src="@/assets/images/card_asterisk.png"/>
              <img class="w-4 h-4" src="@/assets/images/card_asterisk.png"/>
            </div>
            <div class="flex flex-row">
              <span class="text-white text-lg mr-1 font-bold tracking-wide">{{
                  card.last4
                }}</span>
            </div>
          </div>
          <div class="mt-8 flex justify-between items-center text-white">
            <div class="flex flex-col">
              <span class=" text-white text-sm">Owner</span>
              <span class="font-bold">{{ cardOwner }}</span>
            </div>
            <div class="flex flex-col">
              <span class=" text-white text-sm">Expires</span>
              <span class="font-bold">{{ expiresDate }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- No selected card -->
    <div v-else class="my-6 text-sm">
      No payment card selected.
      <span class="text-primary font-semibold cursor-pointer hover:underline" @click="showModal = true">
        Click here
      </span>
      to manage your cards
    </div>

    <!-- add / change card modal -->
    <Modal v-if="showModal" :closeIcon="true" :withoutFooter="true" @close="showModal = false">
      <div slot="body">
        <PaymentSources class="mt-8" @selected="setDefaultPaymentSource"/>
      </div>
    </Modal>

  </div>
</template>

<script>
import ApiV1 from '@/api/api_v1.0'
import Modal from '@/components/common/Modal.vue'
import PaymentSources from '@/components/common/payments/PaymentSourcesComponent'

export default {
  name: 'DefaultPaymentSource',

  components: {
    Modal,
    PaymentSources,
  },

  created () {
    this.getDefaultPaymentSource()
  },

  data () {
    return {
      showModal: false,
      card     : null
    }
  },

  computed: {
    cardType () {
      return this.card?.card_type ? this.card.card_type : 'Card'
    },
    cardOwner () {
      return this.card?.owner ? this.card.owner : 'Not Provided'
    },
    expiresDate () {
      return this.card?.expires_date ? this.card.expires_date : 'Not Provided'
    }
  },

  methods: {
    async getDefaultPaymentSource () {
      const response = await ApiV1.getDefaultPaymentSource()
      this.card = response.data

      if (this.card) {
        this.$emit('selected', true)
        this.$emit('card', this.card)
      }
    },

    async setDefaultPaymentSource (source) {
      this.showModal = false
      await ApiV1.setDefaultPaymentSource(source)

      this.getDefaultPaymentSource()
    }
  }
}
</script>

<style scoped>
.card-gradient {
  background: rgb(154, 71, 50);
  background: linear-gradient(
      180deg,
      rgba(154, 71, 50, 1) 0%,
      rgba(243, 94, 56, 1) 53%,
      rgba(252, 132, 101, 1) 100%
  );
}

.payment-card:hover .visible-on-hover {
  visibility: visible;
}

</style>
